import React from "react";
import { useShortcut } from "@/context/ShortcutsContext";
import { displayCombo } from "@/lib/keyboardDisplay";

/** Small "[Ctrl+D]" chip rendered inline next to a menu label / button.
 *  v1.28.71 — auto-swaps to "⌘D" on macOS. */
export default function ShortcutHint({ action, className = "", inline = true }) {
    const s = useShortcut(action);
    if (!s?.combo) return null;
    const shown = displayCombo(s.combo);
    return (
        <span
            title={`Shortcut: ${shown}`}
            data-testid={`shortcut-hint-${action}`}
            className={`${inline ? "ml-1" : ""} rounded-sm bg-slate-100/70 px-1 py-[1px] font-mono text-[9px] font-semibold uppercase tracking-wider text-slate-500 ring-1 ring-slate-200/60 ${className}`}
        >
            {shown}
        </span>
    );
}
